import { render, staticRenderFns } from "./BulkShow.vue?vue&type=template&id=455c78d0&scoped=true&"
import script from "./BulkShow.vue?vue&type=script&lang=js&"
export * from "./BulkShow.vue?vue&type=script&lang=js&"
import style0 from "./BulkShow.vue?vue&type=style&index=0&id=455c78d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c78d0",
  null
  
)

export default component.exports